import { useState } from "react";
import Chip from "@mui/material/Chip";
import { Button } from "@mui/material";

const SlidingChips = ({
  countries,
  subfolders,
  selectedCountries,
  selectedSubfolders,
  toggleSelection,
  bgColor,
  textColor,
  bigScreen,
  isMobile,
  chipBgColor,
  hasWomenFilter,
  setHasWomenFilter,
  toggleHasWomenFilter,
}) => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 10;

  const allChips = [...countries, ...subfolders];

  const handleNext = () => {
    if (startIndex + visibleCount < allChips.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        id="tags-container"
        style={{
          position: "fixed",
          bottom: "0",
       
          backgroundColor: bgColor,
          padding: "15px",
          width: "96%",
          zIndex: 999,
          display: "flex",
          gap: "0.5rem",
          whiteSpace: "nowrap",
          overflowX: "auto",
          flexWrap: "nowrap",
        }}
      >
        {countries.map((country) => (
          <Chip
            key={country}
            label={country}
            onClick={() => toggleSelection("country", country)}
            className="chip"
            style={{
              backgroundColor: selectedCountries.includes(country)
                ? "#D9D9D9"
                : chipBgColor,
              color: selectedCountries.includes(country) ? "black" : textColor,
              marginRight: "0.2rem",
              fontSize: "0.75rem",
              border: "0.5px solid white",
            }}
          />
        ))}

        {subfolders.map((subfolder) => (
          <Chip
            className="chip"
            key={subfolder}
            label={subfolder}
            onClick={() => toggleSelection("subfolder", subfolder)}
            style={{
              backgroundColor: selectedSubfolders.includes(subfolder)
                ? "#D9D9D9"
                : chipBgColor,
              color: selectedSubfolders.includes(subfolder)
                ? "black"
                : textColor,
              marginRight: "0.2rem",
              fontSize: "0.75rem",
              border: "0.5px solid white",
            }}
          />
        ))}
        <Chip
          label="Women"
          className="chip"
          onClick={toggleHasWomenFilter}
          style={{
            backgroundColor: hasWomenFilter ? "#D9D9D9" : chipBgColor,
            color: hasWomenFilter ? "black" : textColor,
            fontSize: "0.75rem",
            border: "0.5px solid white",
            padding: "8px 12px",
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        />
      </div>
    </div>
  );
};

export default SlidingChips;
